'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import Networks from 'ads-account-connection/lib/Networks';
import { KBArticles } from 'ads-account-connection/lib/Constants';
import KnowledgeBaseLink from 'ads-account-connection/components/KnowledgeBaseLink';
const HELP_LINKS = {
  [Networks.FACEBOOK]: KBArticles.CONNECT_FACEBOOK_ADS_ACCOUNT
};

const MissingAppPermissionsWarning = ({
  network,
  onReauth,
  trackEvent
}) => {
  return /*#__PURE__*/_jsxs(UIAlert, {
    className: "m-bottom-4",
    closeable: true,
    titleText: I18n.text('ADS_ACCOUNT_CONNECTION.missingPermissions.title'),
    type: "danger",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.missingPermissions.message"
    }), /*#__PURE__*/_jsx("br", {}), HELP_LINKS[network] && /*#__PURE__*/_jsx(KnowledgeBaseLink, {
      context: "missing-app-permission-warning",
      kbArticle: HELP_LINKS[network],
      trackEvent: trackEvent,
      className: "m-right-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.missingPermissions.learnMore"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      external: true,
      onClick: onReauth,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.missingPermissions.updatePermissions"
      })
    })]
  });
};

MissingAppPermissionsWarning.propTypes = {
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  onReauth: PropTypes.func,
  trackEvent: PropTypes.func
};
export default MissingAppPermissionsWarning;